import {useModal} from '@hooks';
import {timeLabel} from '@lib/store/src/data/timeslots/dateTimeHelpers';
import {getBuildingEntities, useAppSelector} from '@lib/store';
import {OfficeWorkday} from '@lib/store/src/data/timeslots/apiTypes';
import {useTranslation} from 'react-i18next';
import {StyledModalPage} from 'src/components/organisms/bookWorkspace/BookWorkspaceCard/styles';
import {WorkdayIcon} from '../WorkdayIcon';
import {isPast} from 'date-fns';

interface Props {
  workdays: OfficeWorkday[];
  onSelect: (workday: OfficeWorkday) => void;
}

export const WorkdaySelectorCard = ({workdays, onSelect}: Props) => {
  const {t} = useTranslation();
  const {closeModal} = useModal();

  const buildingEntities = useAppSelector(getBuildingEntities);

  return (
    <StyledModalPage
      title={t('timeslots:SelectWorkday')}
      onClose={closeModal}>
      <ul>
        {workdays.map((workday) => (
          <li
            key={workday.id}
            className="border-b">
            <button
              onClick={() => onSelect(workday)}
              disabled={isPast(new Date(workday.localEnd))}
              className="flex items-center gap-3 w-full p-5 disabled:opacity-70 disabled:cursor-not-allowed md:hover:bg-mapiq-black-50 md:transition-colors">
              <WorkdayIcon
                status="OfficeDay"
                className="bg-energizing-yellow-500*"
              />

              <div className="flex flex-col gap-[2px]">
                <p className="font-semibold leading-4">{buildingEntities[workday.buildingId]?.name}</p>
                <p className="text-mapiq-black-500 text-[13px] leading-4">
                  {timeLabel(workday.localStart, workday.localEnd, t)}
                </p>
              </div>
            </button>
          </li>
        ))}
      </ul>
    </StyledModalPage>
  );
};
